<template>
    <v-content>
      <br>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="9" md="5" lg="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>FullClean V1.0.1</v-toolbar-title>
              </v-toolbar>
              <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12" align="center" justify="center">
                    <v-img src="../assets/logo.png" alt="" width="380" height="290"></v-img>
                  </v-col>
              </v-row>
              
              <v-card-text>
                <v-form>
                  <v-text-field label="Usuario" name="login" v-model="name" prepend-icon="mdi-account" type="text">
                  </v-text-field>
                  <v-text-field label="Contraseña" name="password" v-model="pass" prepend-icon="mdi-lock" 
                  :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'" @keyup.enter="log()"
                  :type="showPass ? 'text' : 'password'" @click:append="showPass = !showPass">
                  </v-text-field>
                </v-form>
                <v-btn color="primary" @click="log()" >Entrar</v-btn>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="log2">Recuperar Contraseña</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <v-dialog v-model="clave" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Recuperar cuenta {{name}}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" v-if="!codigo">
                Se enviara un codigo al correo asociado con la recuperacion de cuenta, una vez enviado
                usted cuenta con 5 minutos para confirmar el codigo y solicitar el restablecimiento de
                su contraseña, presione continuar cuando este ok.
              </v-col>
              <v-col cols="12" v-else>
                <v-text-field v-model="codusr" label="Codigo de validacion" type="text" outlined></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="cancelar">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="solicitarCodigo" v-if="!codigo">Continuar</v-btn>
          <v-btn color="blue darken-1" text @click="cambiarClave" v-else>Confirmar Codigo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    </v-content>
</template>

<script>
import swal from 'sweetalert';
import axios from 'axios';
import api from '../conf/ruta-base';
import router from '../router';
import store from '../store';
import UserProfile from '../data';
export default {
  name: 'Login',
  data: function () {
    return {
      name: '', pass: '', showPass: false, clave: false, codigo: null, codusr: null, idusr: null,
    }
  },
  props: {
    msg: String
  },
  methods: {
      log() {
        if(this.name.length>3 & this.pass.length>0){
          axios
            .post(api.api+'auth',{
              user: this.name,
              pwd: this.pass
            })
            .then(r => {
              if(r.status===200){
                sessionStorage.token = r.data.token;
                UserProfile.setUserData(r.data.data);
                if(r.data.level=='admin'){
                  router.push('/instituciones')
                }else if(r.data.level=='usr'){
                  router.push('/dashboard')
                }else{
                  router.push('/reportes')
                }
                
              }else{
                swal('','Usuario o Contraseña no validos','error');
              }
            })
            .catch(error => {
              swal('','Usuario o Contraseña no validos','error');
              store.commit("loading", false);
            })
            .finally()
        }else{
          swal('Favor ingrese usuario y clave validos');
          
        }
      },
        log2() {
          if(this.name.length<3){
            swal('',`Es necesario su usuario para recuperar su contraseña`,'error')
            return null
          }
          this.clave = true
      },
      cambiarClave(){
        if(this.codigo && this.codusr && this.codigo == this.codusr){
          axios
            .get(api.api+'auth/reset/'+this.idusr)
            .then(r => {
              if(r.data.c='success'){
                swal('',r.data.mensaje,'success')
                this.codigo = null
                this.clave = false
              }else if(r.data.c='error'){
                swal('',r.data.mensaje,'error')
                this.codigo = null
                this.clave = false
              }
            })
            .catch(error => {
              console.log(error);
            })
        }else{
          swal('','No hemos podido validar el codigo ingresado','error')
        }
      },
      solicitarCodigo(){
          axios
            .get(api.api+'auth/codigo/'+this.name)
            .then(r => {
              if(r.data.c=='success'){
                this.codigo = r.data.codtemp
                this.idusr = r.data.id
              }else if(r.data.c=='error'){
                this.codigo = null
                this.clave = false
                swal('',r.data.mensaje,'error')
              }
            })
            .catch(error => {
              console.log(error);
            })        
      },
      cancelar(){
        this.codigo = null
        this.clave = false
        this.codusr = null
        this.idusr = null
      }
    },
    created() {
      this.$vuetify.theme.dark = false
    },
}
</script>